<script lang="ts" setup>
import { ref, onMounted } from "vue";
import BaseVGrid from "@/components/BaseVGrid.vue";
import { getSiteData } from "@/NavigationHelper";
import { goBack } from "@/NavigationHelper";
import { checkNode, globalsKennung } from "@/local";
import { Globals } from "@/Globals";

let showTitle = ref<boolean>(false);
let title = ref<string>("");
let query = ref<string>("Web_Uebersicht_MA_sonstigeBelege");
let initialized = ref<boolean>(false);
let formular = ref<ALLFrame>();
const siteData = getSiteData();
onMounted(async () => {
  if (checkNode("RK_Belegerkennung")) {
    query.value = "Web_persBelegeTabelle";
    // Formualr ans Grid übergeben, damit aus diesem Drucke ausgelesen werden können!
    formular.value = globalsKennung(
      Globals.Begriff,
      "WFMAsonstigeBelegeMitarbeite",
    );
  }
  title.value = "sonstige Belege ";
  if (siteData?.site?.compTitle) {
    showTitle.value = true;
    title.value = siteData.site.compTitle;
  } else if (siteData?.titel) {
    showTitle.value = true;
    title.value = siteData.titel;
  }
  initialized.value = true;
});

// function onReloadData() {
//   const siteData = getSiteData();
//   siteData.onReloadData = true;
// }
</script>
<template>
  <BaseVGrid
    v-if="initialized"
    :query="query"
    :queryAic="siteData?.aic"
    :showClose="true"
    @back="goBack()"
    :showTitle="showTitle"
    :title="title"
    :formular="formular"
  />
  <!-- <BaseVGrid_PrimeVue
    v-if="initialized"
    :query="query"
    :queryAic="siteData?.aic"
    :showClose="true"
    @back="goBack()"
    :showTitle="showTitle"
    :title="title"
    :formular="formular"
  /> -->
</template>

<style scoped></style>
